import Model from 'src/app/common/model';

export default class ItemTypesModel extends Model {
  name: string;
  description?: string;

  constructor() {
    super();
  }
}
